import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { ExpansionPanelComponent, ExpansionPanelImportPack } from '@partners/ui';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  standalone: true,
  imports: [NgIf, ExpansionPanelImportPack, MatExpansionModule, MatRadioModule],
  selector: 'panel-group-item',
  template: `
    <expansion-panel #panel [hasToggle]="!enableToggle" class="panel-group-child" (click)="onPanelClick($event)">
      <ng-template panelTitle>
        <div panel-title class="auto-height">
          <mat-radio-button #radioButton>
            <ng-content select="[panel-header]"></ng-content>
          </mat-radio-button>
        </div>
      </ng-template>

      <ng-template panelBody>
        <div>
          <ng-content select="[panel-body]"></ng-content>
        </div>
      </ng-template>
    </expansion-panel>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelGroupItemComponent<T = unknown> {
  @Input()
  context: T;

  @Input()
  enableToggle: boolean = false;

  @Input()
  bubbleClick: boolean = false;

  @ViewChild(ExpansionPanelComponent)
  panel: ExpansionPanelComponent;

  @ViewChild(MatRadioButton)
  radioButton: MatRadioButton;

  @HostBinding('class.accordion-item--open')
  get isOpen() {
    return this.panel?.isOpen;
  }

  click$: Observable<T>;

  private _click: BehaviorSubject<T>;

  constructor(public content: ViewContainerRef) {
    this._click = new BehaviorSubject<T>(undefined);
    this.click$ = this._click.asObservable();
  }

  onPanelClick(event: MouseEvent | TouchEvent) {
    // event.preventDefault();
    // event.stopPropagation();
    this.panel.open();
    this.radioButton.checked = true;
    this._click.next(this.context);
  }

  close() {
    this.panel.close();
    this.radioButton.checked = false;
  }
}
